import _classCallCheck from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from "react";
import { datadogRum } from "@datadog/browser-rum";
import getConfig from "next/config";
import { isEmpty, get } from "lodash";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import { getIsOnpremise } from "../utils";
import getEnv from "../utils/getEnv";
var isOnpremise = getIsOnpremise();
var DatadogProvider = /*#__PURE__*/function (_React$Component) {
  function DatadogProvider(props) {
    var _this;
    _classCallCheck(this, DatadogProvider);
    _this = _callSuper(this, DatadogProvider, [props]);
    _defineProperty(_this, "initialiseDatadog", function () {
      var _getEnv;
      var _getConfig = getConfig(),
        publicRuntimeConfig = _getConfig.publicRuntimeConfig;
      var commitHash = (_getEnv = getEnv("NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA")) === null || _getEnv === void 0 ? void 0 : _getEnv.substring(0, 7);
      datadogRum.init({
        applicationId: getEnv("NEXT_PUBLIC_DATADOG_APP_ID") || "",
        clientToken: getEnv("NEXT_PUBLIC_DATADOG_CLIENT_TOKEN") || "",
        site: "datadoghq.eu",
        service: getEnv("NEXT_PUBLIC_DATADOG_SERVICE"),
        version: "".concat(publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.version, ".").concat(commitHash),
        env: window && window.location && window.location.hostname,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackLongTasks: true,
        trackResources: true,
        trackUserInteractions: true,
        //trackViewsManually: true,
        defaultPrivacyLevel: "mask-user-input"
      });
      // datadogRum.startSessionReplayRecording();
    });
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _inherits(DatadogProvider, _React$Component);
  return _createClass(DatadogProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (getEnv("NEXT_PUBLIC_APP_ENV") === "production") {
        this.initialiseDatadog();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$user = prevProps.user,
        prevUser = _prevProps$user === void 0 ? {} : _prevProps$user;
      var _this$props = this.props,
        _this$props$user = _this$props.user,
        user = _this$props$user === void 0 ? {} : _this$props$user,
        _this$props$authData = _this$props.authData,
        authData = _this$props$authData === void 0 ? {} : _this$props$authData;
      var organizations = get(authData, "authData", {});
      var sources = get(authData, "sources", []);
      var readSources = get(authData, "read_sources", []);
      var uploadSources = get(authData, "upload_sources", []);
      if (prevUser.email !== user.email && getEnv("NEXT_PUBLIC_APP_ENV") === "production") {
        var _navigator;
        datadogRum.setUser({
          name: user.name && user.name !== "undefined" ? user.name : user.email,
          email: user.email,
          language: (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.language,
          readSources: readSources.map(function (readSource) {
            var name = get(readSource, ["name"], "");
            return name;
          }),
          uploadSources: uploadSources.map(function (uploadSource) {
            var name = get(uploadSource, ["name"], "");
            return name;
          }),
          sources: sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
            if (isEmpty(organizations[source])) {
              return source;
            }
            return organizations[source];
          })
        });
      }
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      if (getEnv("NEXT_PUBLIC_APP_ENV") === "production") {
        datadogRum.addError(error, {
          scope: "error-boundary"
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return /*#__PURE__*/React.createElement(Fallback, null);
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);
}(React.Component);
var Fallback = function Fallback() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var router = useRouter();
  var handleReturn = function handleReturn() {
    router.push("/patients").then(function () {
      router.reload();
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, isOnpremise ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center bold text-gray-900 dark:text-white bg-gray-100 dark:bg-gray-900 w-full h-full"
  }, t("loading_key"), "...") : /*#__PURE__*/React.createElement("div", {
    className: "flex h-full bg-[#0C1723] flex-col justify-center items-center space-y-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative w-[312px] h-[232px] md:w-[588px] md:h-[436px]"
  }, /*#__PURE__*/React.createElement(Image, {
    layout: "fill",
    alt: "error",
    src: "/assets/images/error-image.svg"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: handleReturn,
    className: "bg-gray-800 text-teal-300 text-lg md:text-2xl py-5 md:py-6 px-20 rounded-xl"
  }, t("return_to_worklist"))));
};
export default DatadogProvider;